"use client";
import { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { Session } from "next-auth";
import { useSession } from "next-auth/react";
import { GqlClient } from "@/Providers/gqlClients/GqlClient";

const GQLContext = createContext<{
  session: Session | null;
}>({
  session: null,
});
export const useGqlClient = () => {
  const { session } = useContext(GQLContext);
  const gql = new GqlClient(session);
  return gql.gqlClient;
};

export default function GQLProvider({ children, session }: PropsWithChildren & { session: Session | null }) {
  const { data, update, status } = useSession();
  const s = useMemo(() => {
    return data ?? session;
  }, [data, session]);
  return <GQLContext.Provider value={{ session: s }}>{children}</GQLContext.Provider>;
}
